export default () => {
  const targets =  document.querySelectorAll('.js-target')
  if (targets.length) {
    window.addEventListener('load', () => {
      const url = window.location.href;
      const idFromUrl = url.substring(url.lastIndexOf('#') + 1);
      ;[...targets].forEach(el => {
        const id = el.getAttribute('data-id')
        if(id == idFromUrl){
          let top = el.offsetTop - 120
          let speed
          const currentScrollHeight = document.body.scrollTop || document.documentElement.scrollTop
          const distance = el.offsetTop - currentScrollHeight
          if(distance > 900 || distance < -900){
            speed = 200
          }
          else{
            speed = 500
          }
          if(el.offsetTop > window.innerHeight){
            top = el.offsetTop - 60
          }
          else{
            top = el.offsetTop - 130
          }
          scrollTo(document.body, top, speed); 
        }
      })
    })
    window.addEventListener('hashchange', () => {
      const url = window.location.href;
      const idFromUrl = url.substring(url.lastIndexOf('#') + 1);
      ;[...targets].forEach(el => {
        const id = el.getAttribute('data-id')
        if(id == idFromUrl){

          const currentScrollHeight = document.body.scrollTop || document.documentElement.scrollTop
          console.log(currentScrollHeight);
          let top
          let speed
          const distance = el.offsetTop - currentScrollHeight
          if(distance > 900 || distance < -900){
            speed = 200
          }
          else{
            speed = 500
          }
          if(el.offsetTop > currentScrollHeight && el.offsetTop > window.innerHeight){
             top = el.offsetTop - 50
          }
          else if(el.offsetTop > currentScrollHeight && el.offsetTop >= window.innerHeight){
            top = el.offsetTop - 130
          }
          else if(el.offsetTop < currentScrollHeight){
             top = el.offsetTop - 130
          }
          else {
            top = el.offsetTop
          }
          console.log(top);
          scrollTo(document.body, top, speed); 
        }
      }) 
    })
  } 
  function scrollTo(element, to, duration) {
    var start = document.body.scrollTop || document.documentElement.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;
    var animateScroll = () =>{        
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        document.documentElement.scrollTop = val;
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
  }
  Math.easeInOutQuad = (t, b, c, d) => {
    t /= d/2;
    if (t < 1) return c/2*t*t + b;
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
  };
}



// WEBPACK FOOTER //
// ./src/js/modules/PageScroller.js